var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-view view"},[_c('div',{staticClass:"container vending-machine-checkout wrapper"},[_c('Brukstorget'),_c('br'),_c('RouterLink',{staticClass:"button is-info is-horizontal-middle",attrs:{"to":{ name: 'home' }}},[_vm._v("Till startsidan")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }